export enum GROUP {
  SCHOOL = 'school',
  CLASS = 'class',
  PRACTICE = 'practice',
  FAMILY = 'family',
}
